import { deepCopyJson, iFrameLauncherEvent } from "@classdojo/monsterverse-utils";

import { PCAppEventHandler } from "./PCAppEventHandler";

// ===== MODULE STATE =====
// Shared instances for communication and progress tracking
let pcAppEventHandler: PCAppEventHandler | undefined;

// ===== UPWARD COMMUNICATION =====
// Posts messages from launcher to parent application
export function postToApp(evt: { eventName: string; eventValues?: unknown[] }) {
  if (window.parent !== window) {
    const data = {
      eventName: evt.eventName,
      eventValues: evt.eventValues && deepCopyJson(evt.eventValues),
    };
    try {
      window.parent.postMessage(data, "*");
    } catch (err) {
      const msg = JSON.stringify({ data });
      throw new AggregateError([err], `postMessage failed: launcher MessageHandler.postToApp: ${msg}`);
    }
  }
  pcAppEventHandler?.post(evt);
}

// ===== BIDIRECTIONAL MESSAGE ROUTING =====
// Establishes communication bridge between parent app and iframe
export function handleIFrameMessages(iframeEl: HTMLIFrameElement): PCAppEventHandler {
  // Event handler setup for iframe communication
  pcAppEventHandler = new PCAppEventHandler(iframeEl);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).pc = {
    app: pcAppEventHandler,
  };

  // Message routing system - forwards messages between parent and iframe
  window.addEventListener("message", (ev) => {
    if (ev?.data?.iFrameLauncherEvent !== iFrameLauncherEvent) {
      // Route messages upward (iframe → parent) or downward (parent → iframe)
      if (ev.source === iframeEl.contentWindow) {
        postToApp(ev.data);
      } else {
        try {
          iframeEl.contentWindow?.postMessage(ev.data, "*");
        } catch (err) {
          const msg = JSON.stringify({ data: ev?.data });
          throw new AggregateError([err], `postMessage failed: launcher MessageHandler.handleIFrameMessages: ${msg}`);
        }
      }
    }
  });
  return pcAppEventHandler;
}
